import { BaseBus } from "./BaseBus";

export class Email extends BaseBus
{
  from: string;
  fromName: string;
  to: string;
  subject: string;
    body: string;

    subjectEncoded(): any {
        if (this.subject) {

            return this.subject.replace(/&/g, '%26');

        }

        return "";
    }
    bodyEncoded(): any {
        if (this.body) {

            return this.body.replace(/&/g, '%26');

        }

        return "";
    }
}
